import logo from "../../images/VCallLogo.svg";
import { AppBar, Toolbar, Box, Button } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

const HeaderSignIn: React.FC = () => {
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/signin");
  };
  return (
    <AppBar position="static" style={{ backgroundColor: "#f6b602" }}>
      <Toolbar>
        <Box component="img" src={logo} alt="Logo" sx={{ height: 30, mr: 2 }} />
        <Box sx={{ flexGrow: 1 }} />
        <Button color="inherit" onClick={handleButtonClick}>
          サインイン
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default HeaderSignIn;
